export enum Routes {
  BULK_SEARCH = '/bulk-search',
  DASHBOARD = '/dashboard',
  GETTING_STARTED = '/getting-started',
  HOME = '/',
  ONBOARDING = '/onboarding',
  REPORTS = '/reports',
  SITE_LOOKUP = '/site-lookup',
  SITE_LOOKUP_DASHBOARD = '/site-lookup/dashboards/:dashboardKey',
  TENANT = '/tenant',
  TENANT_INVITATIONS = '/tenant/invitations',
  TENANT_USERS = '/tenant/users',
  TENANT_SUBSCRIPTION = '/tenant/subscription',
}

export const siteLookupDashboardPrefix = '/site-lookup/dashboards';
export const getSiteLookupDashboardRoute = (dashboardKey: string): string => `${siteLookupDashboardPrefix}/${dashboardKey}`;

export default Routes;
